import { Injectable } from '@angular/core';
import { AppServerAPI, ServiceResponse } from '@sdbn/common';
import { Observable } from 'rxjs';
import { BlacklistDetails } from './blacklist-administration.model';

@Injectable({
  providedIn: 'root'
})
export class BlacklistAdministrationService {

  constructor(private appServerAPI: AppServerAPI) { }

  public loadBlacklist(): Observable<BlacklistDetails[]> {
    return this.appServerAPI.execute('/client/admin/blacklist', {});
  }

  public saveBlacklist(blacklist: BlacklistDetails[]): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/client/admin/blacklist/save', blacklist);
  }
}
